module.exports = __webpack_public_path__ + "img/QTEdu-logo-colors@2x.dc895f4a.png";